import { combineReducers } from "redux";

import { channelsReducer } from "./reducer-channels";
import { tokenReducer } from "./reducer-studio";
import { editorReducer } from "./reducer-editor";
import { viewerReducer } from "./reducer-viewer";

const reducers = combineReducers({
  channels: channelsReducer,
  studio: tokenReducer,
  editor: editorReducer,
  viewer: viewerReducer,
});

export default reducers;
export type RootState = ReturnType<typeof reducers>;
